import React, { memo } from "react";
import { useContext } from "react";
import { createUseStyles } from "react-jss";
import { BotContext } from "../context";
const useStyles = createUseStyles((theme) => ({
  invalid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: theme.invalidTokenContainerBg,
    borderRadius: 10
  },
  text: {
    color: "white",
    background: theme.invalidTokenBg,
    padding: [10, 20],
    borderRadius: 5,
  },
}));
const InvalidToken = memo(() => {
  const styles = useStyles();
  const { config } = useContext(BotContext)
  return (
    <div className={styles.invalid}>
      <div className={styles.text}>{config.inValidTokenMessage}</div>
    </div>
  );
});

export default InvalidToken;
